import React, { useState, useEffect } from "react";
import { RiArrowDropDownLine } from "react-icons/ri";
import HeadingArea from "../../general/HeadingArea";
import { AiOutlineSearch } from "react-icons/ai";
import ResponseMsg2 from "../../general/ResponseMsg2";
import { FaCheck } from "react-icons/fa";

const EmployeeAttendance = ({setLoading}) => {
const [selectedDate, setSelectedDate] = useState('');
  const [selectedRole, setSelectedRole] = useState("");
const [emp, setEmp] = useState([]);
    const [response2, setResponse2] = useState({ message: '', status: 'success' });
const [attendanceData, setAttendanceData] = useState({});
  const [academicYears, setAcademicYears] = useState([]);
  const [selectedAY, setSelectedAY] = useState('');
  const [showMark, setShowMark] = useState(false);
const [searchTerm, setSearchTerm] = useState('');


    const handleSearch = async (e) => {
    e.preventDefault();

    setLoading(true);

    try {

      const response = await fetch(`https://api.kcian.in/get-employee`);

      if (response.ok) {
        const data = await response.json();
const filtered = data.filter((employee) => employee.role === selectedRole);
setEmp(filtered);

         const defaultAttendance = {};
  data.forEach((emp) => {
    defaultAttendance[emp.id] = {
      attendance: 'Present',
      note: ''
    };
  });
  setAttendanceData(defaultAttendance);

} else {
        console.error('Failed to fetch staff');
      }
    } catch (error) {
      console.error('Error fetching staff:', error);
    } finally {
      setLoading(false);
    }
  };

    const fetchAcademicYears = async () => {
    setLoading(true);
    try {
      const response = await fetch('https://api.kcian.in/get-academic-years');
      if (response.ok) {
        const data = await response.json();
        const sortedData = data.sort((a, b) => b.id - a.id);
        setAcademicYears(sortedData);
      } else {
        console.error('Failed to fetch academic years');
      }
    } catch (error) {
      console.error('Error fetching data:', error);
    } finally {
      setLoading(false);
    }
  };


    useEffect(() => {
      fetchAcademicYears();
    }, []);

    const handleSaveAttendance = async (markHoliday = null) => {

      const monthName = new Date(selectedDate).toLocaleString('default', { month: 'long' });


const payload = emp.map((student) => ({
  empId: student.id,
  date: selectedDate,
  month: monthName,
  mark: markHoliday ? markHoliday : attendanceData[student.id]?.attendance || '',
  note: markHoliday ? markHoliday : attendanceData[student.id]?.note || '',
  ay: selectedAY
}));


  setLoading(true);
  try {
    const response = await fetch('https://api.kcian.in/save-staff-attendance', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ records: payload }),
    });

    if (response.ok) {
        setResponse2({ message: 'Attendance saved successfully!', status: 'success' });
        setShowMark(false);
        setTimeout(() => {
          setResponse2('');
        }, 2000);
        setAttendanceData({});
      // Optionally reset form or show a success message
    } else {
                 setResponse2({ message: 'Something Went Wrong. Please try again.', status: 'error' });
        setTimeout(() => {
          setResponse2('');
        }, 2000);
    }
  } catch (error) {
    console.error('Error saving attendance:', error);
  } finally {
    setLoading(false);
  }
};


 const filteredEmp = emp.filter((cls) => {
  const term = searchTerm.toLowerCase();

  return (
    String(cls.name || '').toLowerCase().includes(term)
  );
});


  return (
<>
      <section className='py-4'>
        <div className='px-4'>
          <HeadingArea message1='Attendance' message2='Employees Attendance' />

          <form className='profile-card' onSubmit={handleSearch}>
            <span className="profile-heading">Select Criteria</span>

<div className="row mt-3">

                <div className="col-lg-3 col-md-6 col-6 mb-4">
                <div className='profile-input-area'>
                  <label className="profile-badge">Select AY*</label>
                  <select
                    className="profile-input"
                    value={selectedAY}
                    onChange={(e) => setSelectedAY(e.target.value)}
                    required
                  >
                    <option value="">-- Select Academic Year --</option>
                    {academicYears.map((ay) => (
                      <option key={ay.year} value={ay.year}>
                        {ay.year} --- {ay.title}
                      </option>
                    ))}
                  </select>
                </div>
              </div>


              <div className="col-lg-4 col-md-6 col-6 mb-4">
                <div className='profile-input-area'>
                  <label className="profile-badge">Select Role*</label>
                  <select
                    className="profile-input"
                    value={selectedRole}
                    onChange={(e) => setSelectedRole(e.target.value)}
                    required
                  >
                    <option value="">-- Select Role --</option>
                    <option value="Teacher">Teacher</option>
                    <option value="Librarian">Librarian</option>
                    <option value="Accountant">Accountant</option>
                    <option value="Driver">Driver</option>
                    <option value="Other">Other</option>
                  </select>
                </div>
              </div>


              <div className="col-lg-3 col-md-6 col-12 mb-4">
  <div className='profile-input-area'>
    <label className="profile-badge">Select Date*</label>
    <input 
      type="date" 
      className="profile-input" 
      value={selectedDate} 
      onChange={(e) => setSelectedDate(e.target.value)} 
      required
    />
  </div>
</div>

            <div className='col-lg-2 col-md-6 col-12 align-content-center mb-4'>
              <button type='submit' className='profile-btn2'>
                <AiOutlineSearch /> Search
              </button>
            </div>


</div>
</form>
{/* form ends */}


          <div className='profile-card mt-3'>
            <span className="profile-heading">Role: {selectedRole}, Date: {selectedDate}</span>
            {/* Render student list here */}

       {response2.message && <ResponseMsg2 message={response2.message} status={response2.status} />}

<br />
{emp.length != 0 && 
<div className='d-md-flex justify-content-between'>
{!showMark && <button className='profile-btn mt-2' onClick={() => setShowMark(true)}>Mark Holiday</button>}

{showMark && (
<>
<p className='fw-semibold mt-2'>Want to mark Today as Holiday?</p>
            <button className='profile-btn me-2' onClick={() => handleSaveAttendance('Holiday')}>Yes</button>
            <button className='profile-btn2' onClick={() => setShowMark(false)}>No</button>
</>
)}

  <div className='profile-input-area ms-auto col-lg-3 border-0'>
<input
  type='text'
  name='search'
  className='profile-input border-bottom rounded-0'
  placeholder='Search by Name'
  value={searchTerm}
  onChange={(e) => setSearchTerm(e.target.value)}
/>
</div>
</div>
}

            <div className='table-responsive my-3'>
<table className='w-100'>

<thead className='account-thead'>
    <th className='rounded-start-4'>Staff No</th>
    <th>Name</th>
    <th>Staff Id</th>
    <th>Attendance</th>
    <th className='rounded-end-4'>Note</th>
</thead>

            {filteredEmp.length === 0 ? (
              <tr className='text-center account-tr'><td colSpan={8}>No Employee Data found</td></tr>
            ) : (
              <>
                {filteredEmp.map((emps) => (
  <tr className='account-tr' key={emps.id}>
    <td>{emps.id}</td>
    <td>{emps.name}</td>
    <td>{emps.user_id}</td>
<td>
  <div className='d-flex gap-2'>
    {['Present', 'Absent', 'Half Day' , 'Leave'].map((status) => (
      <label key={status}>
        <input
          type="radio"
          name={`attendance-${emps.id}`}
          value={status}
          checked={attendanceData[emps.id]?.attendance === status}
          onChange={() =>
            setAttendanceData((prev) => ({
              ...prev,
              [emps.id]: {
                ...prev[emps.id],
                attendance: status,
              },
            }))
          }
        />{' '}
        {status}
      </label>
    ))}
  </div>
</td>

<td>
              <div className='profile-input-area'>
  <input
    type="text"
    placeholder="Add Note Here"
    className="profile-input"
    value={attendanceData[emps.id]?.note || ''}
    onChange={(e) =>
      setAttendanceData((prev) => ({
        ...prev,
        [emps.id]: {
          ...prev[emps.id],
          note: e.target.value,
        },
      }))
    }
  />
  </div>
</td>
                    </tr>
                ))}
              </>
            )}
</table>
</div>

<div className='text-center'>
<button className='profile-btn' onClick={() => handleSaveAttendance(null)}>
  <FaCheck /> Save Attendance
</button></div>

</div>


          </div>
          </section>
    </>
  );
};

export default EmployeeAttendance;
